var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noDeliver",style:({zIndex: _vm.zIndexNum,})},[_c('div',{staticClass:"restock-text",class:['restock-text',_vm.getDFLANG()?'no-deliver-font-12':'']},[_vm._v(_vm._s(_vm.getDFLANG()?'Unavailable': '不可配送'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }